import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { useProgressContext } from './Context';
import { progressTheme } from './theme';
const CircleProgressLine = forwardRef(({ className, strokeWidth = 3.5, strokeColor, ...props }, ref) => {
    const { circle } = progressTheme;
    const { progressBar = 0 } = useProgressContext();
    return (_jsxs("svg", { ...props, ref: ref, className: circle.svg.base, viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: 18, cy: 18, r: 16, fill: "none", className: cn(circle.svg.circle, className), strokeWidth: strokeWidth }), _jsx("g", { className: circle.svg.g, children: _jsx("circle", { cx: 18, cy: 18, r: 16, fill: "none", className: cn(circle.svg.gCircle, strokeColor), strokeWidth: strokeWidth + 0.2, strokeDasharray: 100, strokeDashoffset: 100 - progressBar }) })] }));
});
CircleProgressLine.displayName = 'CircleProgressLine';
export { CircleProgressLine };
